export default __webpack_public_path__ + "static/media/shopify.2b7b2a2c.svg";